import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Placeholder = _resolveComponent("Placeholder")!
  const _component_GridColumn = _resolveComponent("GridColumn")!
  const _component_GridContainer = _resolveComponent("GridContainer")!
  const _component_ListItem = _resolveComponent("ListItem")!
  const _component_ListPagination = _resolveComponent("ListPagination")!
  const _component_ResponsiveComponent = _resolveComponent("ResponsiveComponent")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_InViewport = _resolveComponent("InViewport")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading && !_ctx.isInfinity)
      ? (_openBlock(), _createBlock(_component_GridContainer, { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPlaceholderItems(), (index) => {
              return (_openBlock(), _createBlock(_component_GridColumn, {
                size: 3,
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Placeholder, { class: "placeholder" })
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading || _ctx.isInfinity)
      ? (_openBlock(), _createBlock(_component_GridContainer, { key: 1 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagedItems, (item, index) => {
              return (_openBlock(), _createBlock(_component_GridColumn, {
                size: 3,
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ListItem, { item: item }, null, 8, ["item"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ResponsiveComponent, {
      device: "desktop",
      onOnChange: _ctx.toggleInfinity
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ListPagination, {
          currentPage: _ctx.currentPage,
          totalItems: _ctx.totalItems,
          perPage: _ctx.perPage,
          onPageChanged: _ctx.paginationChange
        }, null, 8, ["currentPage", "totalItems", "perPage", "onPageChanged"])
      ]),
      _: 1
    }, 8, ["onOnChange"]),
    (_ctx.items.length > 0 && _ctx.items.length < _ctx.totalItems)
      ? (_openBlock(), _createBlock(_component_ResponsiveComponent, {
          key: 2,
          device: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InViewport, { onOnEnter: _ctx.viewMoreInViewport }, {
              default: _withCtx(() => [
                _createVNode(_component_Loading)
              ]),
              _: 1
            }, 8, ["onOnEnter"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}